import { AnaColumn } from "../forms-template.service";

export const crmEstrattoConto: AnaColumn[] = [
    {
        configuration:
        {
            // service: 'elencoAttivitaGrid',
            // api: 'diario',
            // api_rest: true,
            // filterList: '',
            // filterEditor: '/$',
            // formType: 'simple',
            // queryFilter: [],
            // idTabRif: [],
            // costantValues: [],
            // masterKey: 'id',
            // nCol: 1,
        },
        itemType: 'group',
        caption: '',
        class: '',
        colCount: '1',
        data: [
            {
                type: 'campo',
                dataField: 'COD',
                visible: false,
                colVisible: false,
                dataType: 'string',
                caption: 'ID',
                colAlignment: 'center',
            },
            {
                type: 'campo',
                dataField: 'DATAR',
                visible: true,
                dataType: 'string',
                caption: 'Data Registrazione',
                colAlignment: 'center',
                colWidth: 120,
            },
            {
                type: 'campo',
                dataField: 'CAU',
                visible: true,
                dataType: 'string',
                caption: 'Causale',
                colAlignment: 'center',
                colWidth: 70,
            },
            {
                type: 'campoData',
                dataField: 'DATADOC',
                colVisible: true,
                format: "dd/MM/yyyy",
                editorType: "dxDateBox",
                dataType: 'date',
                caption: 'Data documento',
                showClearButton: true,
                showDropDownButton: false,
                colAlignment: 'center',
                colWidth: 120,
            },
            {
                type: 'campo',
                dataField: 'NUMDOC',
                visible: true,
                dataType: 'string',
                caption: 'Numero documento',
                colAlignment: 'center',
                colWidth: 120,
            },
            {
                type: 'campo',
                dataField: 'des',
                visible: true,
                dataType: 'string',
                caption: 'Descrizione',
                colAlignment: 'left',
                colWidth: 300,
            },
            {
                type: 'campo',
                dataField: 'iva',
                visible: true,
                dataType: 'string',
                caption: 'IVA',
                colAlignment: 'center',
                colWidth: 50,
            },
            {
                type: 'campo',
                dataField: 'ccr',
                visible: true,
                dataType: 'string',
                caption: 'CCR',
                colAlignment: 'center',
                colWidth: 50,
            },
            {
                type: 'campo',
                dataField: 'dare',
                visible: true,
                dataType: 'string',
                caption: 'Dare',
                colAlignment: 'right',
                colWidth: 100,
            },
            {
                type: 'campo',
                dataField: 'avere',
                visible: true,
                dataType: 'string',
                caption: 'Avere',
                colAlignment: 'right',
                colWidth: 100,
            },
            {
                type: 'campo',
                dataField: 'saldo',
                visible: true,
                dataType: 'string',
                caption: 'Saldo',
                colAlignment: 'right',
                colWidth: 100,
            },
        ]
    }
];